import React from 'react';
import type { FC } from 'react';

import ReactQueryClientProvider from 'src/contexts/ReactQueryClientProvider';

import MaintenancePage from 'src/views-new/MaintenancePage';

import ApolloProvider from 'src/interviewer-portal/contexts/ApolloProvider';
import { InterviewerSupportedLocalesProvider } from 'src/interviewer-portal/contexts/InterviewerSupportedLocalesProvider';
import { useSyncInterviewerLocale } from 'src/interviewer-portal/hooks/useSyncInterviewerLocale';
import InterviewerPortalSessionActivityTimeout from 'src/interviewer-portal/InterviewerPortalSessionActivityTimeout';
import { interviewerRoutes, renderRoutes } from 'src/routes';

const SyncInterviewerLocale: FC<{ children: React.ReactNode }> = ({ children }) => {
  useSyncInterviewerLocale();
  return <>{children}</>;
};

const App: FC = () => {
  return (
    <ReactQueryClientProvider>
      <ApolloProvider>
        <InterviewerSupportedLocalesProvider>
          <SyncInterviewerLocale>
            <InterviewerPortalSessionActivityTimeout />
            <MaintenancePage>
              <>{renderRoutes(interviewerRoutes)}</>
            </MaintenancePage>
          </SyncInterviewerLocale>
        </InterviewerSupportedLocalesProvider>
      </ApolloProvider>
    </ReactQueryClientProvider>
  );
};

export default App;
